import { useCallback, type MutableRefObject } from 'react';

type RefCallback<T> = (instance: T | null) => void;
type RefType<T> = MutableRefObject<T | null> | RefCallback<T> | null;

/**
 * Shares ref between multiple refs
 * @see https://stackoverflow.com/questions/62238716/using-ref-current-in-react-forwardref/76485900#76485900
 */
export const useSharedRef = <T>(...refs: RefType<T>[]): RefCallback<T> =>
	useCallback(
		(instance: T | null) => {
			for (const ref of refs) {
				if (typeof ref === 'function') {
					ref(instance);
				} else if (ref) {
					ref.current = instance;
				}
			}
		},
		[refs],
	);
